module.exports = __webpack_public_path__ + "media/images/fr-portrait-49844b8e.png";